import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { RestaurantService } from '../../services/restaurant.service';
import { Restaurant } from '../../models/restaurant.model';

@Component({
  selector: 'app-top-bar', // Ensure this matches what you use in the template
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
})
export class TopBarComponent implements OnInit {
  restaurants: Restaurant[] = [];
  @Output() restaurantSelected = new EventEmitter<Restaurant>();

  constructor(private restaurantService: RestaurantService) {}

  ngOnInit(): void {
    this.restaurants = this.restaurantService.getRestaurants();
  }

  onRestaurantChange(event: Event): void {
    const selectedRestaurantName = (event.target as HTMLSelectElement).value;
    const selectedRestaurant = this.restaurants.find(
      (restaurant) => restaurant.name === selectedRestaurantName,
    );
    if (selectedRestaurant) {
      this.restaurantSelected.emit(selectedRestaurant);
    }
  }
}
